import axios from "axios";

export const getFile = async (params) => {
    try {
        var options = {
            async: true,
            crossDomain: true,
            responseType: 'blob',
        };

        return await axios
            .get(params, options)
            .then((res) => {
                if (res.status === 200) {
                    const regExpFilename = /filename="(?<filename>.*)"/;
                    const filename = regExpFilename.exec(res.headers['content-disposition'])?.groups?.filename ?? null;
                    const url = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                }
                return res;
            })
            .catch((err) => {
                console.log(err.response)
                return err.response;
            });
    } catch (error) {
        console.log(error);
    }
};

export const getPdfFile = async () => {
    try {
        var options = {
            async: true,
            crossDomain: true,
            responseType: 'blob',
        };
        return await axios
            .get(`/getpdffile`, options)
            .then((result) => {
                return result;
            })
            .catch((err) => {
                return err.response;
            });
    } catch (error) {
        console.log(error);
    }
};